<template>
  <div>
    <table class="table table-bordered table-sm">
      <thead>
        <tr>
          <th>PRODUCTO</th>
          <th title="Cantidad">CANT.</th>
          <th title="Precio Unitario">P.U.</th>
          <th class="text-right" title="Subtotal">SUB.T.</th>
        </tr>
        <tr v-for="(l, i) in list" :key="i">
          <td>{{ l.name }}</td>
          <td class="text-center">
            <!-- {{ l.quantity }} -->
            <NumberControl
              :disabled="disabled"
              v-model="l.quantity"
            ></NumberControl>
          </td>
          <td class="text-right text-nowrap">
            <app-span-input v-model.number="l.unit_price" :disabled="disabled">
              {{ l.unit_price | money }}
            </app-span-input>
          </td>
          <td class="text-nowrap text-right">
            {{ (l.quantity * l.unit_price) | money }}
          </td>
        </tr>
        <tr>
          <th class="text-right" colspan="3">TOTAL</th>
          <th class="text-nowrap text-right">{{ total | money }}</th>
        </tr>
      </thead>
    </table>
  </div>
</template>
<script>
import NumberControl from "./NumberControl.vue";

export default {
  components: {
    NumberControl
  },

  // directives
  // filters

  props: {
    disabled: {
      default: false
    },
    list: {
      default: () => {
        return [];
      },
      type: Array
    }
  },

  data: () => ({
    //
  }),

  computed: {
    total() {
      return this.list
        .map((x) => x.quantity * x.unit_price)
        .reduce((p, c) => p + c, 0);
    }
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    getTotal() {
      return this.total;
    }
  }
};
</script>

<style scoped></style>
